export default "__VITE_ASSET__ad733a4b__"